import React, { useContext } from 'react';
import { FilterContext } from '../../context/Filter';

const Vehiclepagecard = (props) => {
    const { open } = useContext(FilterContext); // true = sidebar open


    return (

        <div className={`shadow-[0_4px_5px_-1px_rgba(59,130,206,0.5)] m-2 border pr-2 w-80 md:w-full gap-2 pt-2 rounded-xl ml-5 text-gray-900   `} >
            <div className='flex gap-3 rounded-lg justify-center justify-items-center'>
                <div className='flex justify-items-center justify-center '>
                    {props.logo && (
                        <img src={props.logo} alt="logo" className="w-8 h-12 mb-1 text-left" />
                    )}
                </div>
                <div className='flex-col pl-2 pr-2 gap-2'>


                    <div className='text-sm text-gray-700  font-semibold rounded-sm'>{props.heading}</div>
                    <div className='text-md justify-center font-bold  text-gray-700 text-center rounded-sm'>{props.value}</div>
                    <div className='text-xs text-[#31BB31] rounded-sm'>{props.des}</div>
                </div></div >                </div>


    );
};

export default Vehiclepagecard;
